import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import OAuthInput from './shared/OAuthInput';
import OAuthButton from './shared/OAuthButton';

const Heading = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: ${p => p.theme.text};
  text-align: center;
  margin-bottom: 8px;
  line-height: 32px;
`;

const Subtext = styled.p`
  font-size: 15px;
  font-weight: 400;
  color: ${p => p.theme.textSecondary};
  text-align: center;
  line-height: 24px;
  margin-bottom: 24px;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: ${p => p.theme.border};
`;

const DividerText = styled.span`
  font-size: 13px;
  color: ${p => p.theme.textTertiary};
`;

const Footer = styled.div`
  text-align: center;
  font-size: 13px;
  color: ${p => p.theme.textTertiary};
  line-height: 18px;

  a {
    color: ${p => p.theme.textTertiary};
    text-decoration: underline;
    &:hover { color: ${p => p.theme.textSecondary}; }
  }
`;

export default function EmailStep({ email, setEmail, headers, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();

    if (!trimmed || !trimmed.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch('/oauth/web/send_otp', {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ email: trimmed }),
      });

      const data = await response.json();

      if (response.ok) {
        onSuccess(data);
      } else {
        setError(data.error_description || 'An error occurred.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [email, headers, onSuccess]);

  return (
    <form onSubmit={handleSubmit}>
      <Heading>Sign in</Heading>
      <Subtext>Enter your email address to continue.</Subtext>

      <OAuthInput
        label="Email address"
        type="email"
        placeholder="you@example.com"
        value={email}
        onChange={(e) => { setEmail(e.target.value); setError(null); }}
        error={error}
        autoFocus
        autoComplete="email"
      />

      <OAuthButton type="submit" loading={loading} disabled={!email.trim()}>
        Continue
      </OAuthButton>

      <Divider>
        <DividerLine />
        <DividerText>or</DividerText>
        <DividerLine />
      </Divider>

      <Footer>
        Don&apos;t have an account?{' '}
        <a href="https://tezlabapp.com" target="_blank" rel="noopener noreferrer">
          Get TezLab
        </a>
      </Footer>
    </form>
  );
}
